<template>
  <section class="rewards-group">
    <h6>{{ headline }}</h6>
    <div class="container">
      <rewards-item
        v-for="(paragraphs, index) in items"
        :key="index"
        :paragraphs="paragraphs"
        :src="iconSrc"
        :alt="iconAlt"
      />
    </div>
  </section>
</template>

<script>
import RewardsItem from './RewardsItem.vue';

export default {
  components: {
    RewardsItem,
  },
  props: {
    headline: String,
    iconSrc: String,
    iconAlt: String,
    items: Array,
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables';
@import '~@/assets/styles/breakpoints';

.container {
  display: flex;
  flex-wrap: wrap;
  max-width: $page-laptop-breakpoint;
  justify-content: space-between;
}

.rewards-group {
  margin: 0 15px 40px;
}

h6 {
  margin-bottom: 24px;
}
</style>
